var map = {
	"./account.svg": "b4d3",
	"./dashboard.png": "2e95",
	"./delivery-addresses.svg": "155c",
	"./delivery-schedule.svg": "3596",
	"./free-boxes.svg": "9163",
	"./gift.svg": "66b5",
	"./rate-my-flowers.svg": "fe36",
	"./send-a-gift.svg": "fc5f",
	"./shop.svg": "d843",
	"./your-boxes.svg": "2502"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fb19";